import React from 'react';

import { useMetricsConfig } from '../../hooks/useMetricsConfig';
import { Metrics as MetricsUI, MetricsProps as MetricsUIProps } from './Metrics';

type ConnectedProps = Omit<
    MetricsUIProps,
    | 'isPendoEnabled'
    | 'customer'
    | 'instance'
    | 'user'
    | 'isUserImpersonated'
    | 'currentLanguage'
    | 'hasAcceptedCookies'
>;

export const Metrics: React.FC<ConnectedProps> = (props) => {
    const { isPendoEnabled, customer, instance, user, isUserImpersonatedValue, currentLanguage, hasAcceptedCookies } =
        useMetricsConfig();

    return (
        <MetricsUI
            {...props}
            isPendoEnabled={isPendoEnabled}
            customer={customer}
            instance={instance}
            user={user}
            isUserImpersonated={isUserImpersonatedValue}
            currentLanguage={currentLanguage}
            hasAcceptedCookies={hasAcceptedCookies}
        />
    );
};

Metrics.displayName = 'MetricsConnected';
